import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const TimespanRecord = Record({
  years: 0,
  months: 0,
  weeks: 0,
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0
});

createFromJS.registerCallback("TimespanRecord", createFromJS.createPrimitiveCallback(TimespanRecord));
